<app-page-header
  [title]="'Acessar conta'"
  [titleIcon]="'pi pi-user'"
  [subtitle]="'Preencha o email e a senha para realizar o login.'"
  [headerFlexWrap]="false">
  <div class="container-button-close">
    <button type="button" class="btn-close" aria-label="Close" (click)="dialogRef.close()"></button>
  </div>
</app-page-header>
<mat-dialog-content>
  <div class="modal-body--social-login">
    <div class="section-header">
      <span>Entre com suas redes sociais:</span>
    </div>
    <app-social-login
      (loginWithSocialMedia)="handleLoginWithSocialMedia($event)"
      (loginWithApple)="handleLoginWithApple()" />
  </div>
  <div class="modal-body--login-form">
    @if (!mfaPending) {
      <div class="section-header">
        <span>Ou com seu login e senha:</span>
      </div>
      <form [formGroup]="loginForms" (ngSubmit)="onSubmit()">
        <div class="mb-3">
          <label for="email" class="form-label">Email</label>
          <input type="email" class="form-control" id="email" formControlName="email" />
          @if (loginForms.get('email')?.invalid && loginForms.get('email')?.touched) {
            <div class="invalid-feedback">
              Por favor, insira um email válido.
            </div>
          }
        </div>
        <div class="mb-3">
          <label for="password" class="form-label">Senha</label>
          <input type="password" class="form-control" id="password" formControlName="password" />
          <small>
            Esqueceu sua senha? <a href="#" (click)="forgotPassword(); $event.preventDefault()">Clique aqui</a>
            <br />
            <div class="d-flex flex-wrap gap-1">
              Problemas com a confirmação da conta?
              <div class="d-flex gap-1">
                <a href="#" (click)="resendConfirmation(); $event.preventDefault()">Reenviar</a>
              </div>
            </div>
            <div class="d-flex flex-wrap gap-1">
              Ainda não possui uma conta?
              <div class="d-flex gap-1">
                <a href="#" (click)="openModalSignUp(); $event.preventDefault()">Crie aqui!</a>
              </div>
            </div>
          </small>
          @if (loginForms.get('password')?.invalid && loginForms.get('password')?.touched) {
            <div
              class="invalid-feedback">
              A senha deve ter no mínimo 6 caracteres.
            </div>
          }
        </div>
      </form>
    } @else {
      <div class="section-header">
        <span>Verificação em duas etapas</span>
      </div>
      <div class="login-mfa">
        <p class="alert alert-info">
          Enviamos um código de 6 dígitos por {{ mfaChannelsLabel || "e-mail, SMS e WhatsApp" }}.
        </p>
        <p>Digite o código para concluir o login.</p>
        <p-inputOtp [(ngModel)]="mfaCode" [length]="6" [integerOnly]="true" [disabled]="isLoading" />
        <app-button [disabled]="isLoading" (btnClick)="verifyMfa()">Verificar código</app-button>
        <app-button styleType="outlined" [disabled]="isLoading || isMfaTimerActive" (btnClick)="resendMfa()">
          Reenviar código
        </app-button>
        @if (isMfaTimerActive) {
          <p>
            Aguarde <strong>{{ mfaTimer }}</strong> segundos para reenviar.
          </p>
        }
        <a href="#" (click)="backToPassword(); $event.preventDefault()">Voltar ao login e senha</a>
      </div>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="gap-2">
  @if (!mfaPending) {
    <app-button styleType="secondary" (btnClick)="openModalSignUp()">Cadastre-se</app-button>
    <app-button (btnClick)="onSubmit()">Efetuar Login</app-button>
  }
</mat-dialog-actions>

@if (isLoading) {
  <app-loading />
}
